import React from 'react'
import Navbar from '../components/Navabr/Navbar'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import Siderbar from '../components/Sidebar/Siderbar';
import PrivateRoute from '../PrivateRoute';

function Layout() {
  const location = useLocation();
  const isLoginScreen = location.pathname === '/signin';
  return (
    <>

      <div className="container-fluid">
        <div className="row">
          {!isLoginScreen && <div className="col-lg-2 bg-primary shadow d-none d-lg-block" style={{ height: "100vh",overflowY:"auto"}}>
            <Siderbar />
          </div>}
          <div className="col-lg-10" style={{height:"100vh",overflowY:"scroll"}}>
            <div className="row">
              {!isLoginScreen && <div className='bg-primary'>
                <Navbar />
              </div>}
            </div>
            <div className=''>
              <PrivateRoute Component={Outlet} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout